export enum SDPCategoryEnum {
  YMR = 'YMR',
  SMART = 'SMART',
  SMR = 'SMR',
}
